<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="accountEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} activation
          <app-creator-modifier-icon style="float: right; margin-right: 10px" [object]="Copy"></app-creator-modifier-icon></h2>
        <mat-dialog-content *ngIf="Copy">
            <mat-tab-group>
                <mat-tab label="General">
                    <div class="row">
                        <div class="col-md-4">
                            <app-dropdown-option name="Type" model="Activation" discriminator="Type" [(ngModel)]="Copy.Type" placeholder="Type" required></app-dropdown-option>
                        </div>
                        <div class="col-md-4">
                            <app-account-selector name="Representative" [(ngModel)]="Copy.Representative" placeholder="Representative"></app-account-selector>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field>
                              <mat-label>Max amount (confirmed) students</mat-label>
                                <input matInput name="StudentAmount" type="number" [(ngModel)]="Copy.AmountOfStudents">
                                <mat-hint>When this amount is reached, the demo status will change to Confirmed</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Add emails to send representative mails to</mat-label>
                                <mat-chip-grid #chipList>
                                    <mat-chip-row *ngFor="let email of Copy.ExtraEmails" [selectable]="true"
                                              [removable]="true" (removed)="Copy.ExtraEmails.splice(Copy.ExtraEmails.indexOf(email), 1)">
                                        {{email}}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-row>
                                    <input #emailInput type="email"
                                           [matChipInputFor]="chipList"
                                           [matChipInputAddOnBlur]="true"
                                           (matChipInputTokenEnd)="addEmail($event.value, emailInput);">
                                </mat-chip-grid>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <app-relation-selector name="Relation" [(ngModel)]="Copy.Relation" [filter]="{include: _Relation.WithoutGoogleMapsInclude}"></app-relation-selector>
                        </div>
                        <div class="col-md-6">
                            <app-dropdown-option name="Status" model="Activation" discriminator="Status" [(ngModel)]="Copy.Status" placeholder="Status" required></app-dropdown-option>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Address</mat-label>
                                <mat-select name="Address" [(ngModel)]="Copy.Address"
                                            [compareWith]="compareWith" required>
                                    <ng-container *ngIf="Copy.Relation">
                                        <mat-option *ngFor="let address of Copy.Relation.Addresses"
                                                    [value]="address" style="line-height: normal;">
                                            {{address.Street}} {{address.Number}} {{address.BusNumber}} | {{address.Type?.Value}}<br>
                                            {{address.City}} {{address.Postcode}} {{address.Country?.Name}}
                                        </mat-option>
                                        <mat-option *ngIf="Copy.Relation" (click)="aEditor.edit({Relation: Copy.Relation})">
                                            <mat-icon>add</mat-icon>
                                            Add Address
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Contact person</mat-label>
                                <mat-select name="Contact" [(ngModel)]="Copy.Contact"
                                            [compareWith]="compareWith" required>
                                    <ng-container *ngIf="Copy.Relation">
                                        <mat-option *ngFor="let contact of Copy.Relation.Contacts"
                                                    [value]="contact">
                                          {{contact.Fullname}}
                                        </mat-option>
                                        <mat-option *ngIf="Copy.Relation" (click)="cEditor.edit({Relation: Copy.Relation})">
                                            <mat-icon>add</mat-icon>
                                            Add Contact
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field>
                          <mat-label>Start date</mat-label>
                          <input name="Start"
                                 [ngModel]="Copy.Start | date: 'yyyy-MM-dd\THH:mm'"
                                 (ngModelChange)="Copy.Start = $event" matInput type="datetime-local">
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field>
                          <mat-label>End date</mat-label>
                          <input name="End"
                                 [ngModel]="Copy.End | date: 'yyyy-MM-dd\THH:mm'"
                                 (ngModelChange)="Copy.End = $event" matInput type="datetime-local">
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Instructions</mat-label>
                                <textarea name="Instructions" matInput [(ngModel)]="Copy.Instructions"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <app-locale-selector name="Locale" [(ngModel)]="Copy.Locale" placeholder="Language" required></app-locale-selector>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <mat-checkbox name="IsAutomaticallyNotified" [(ngModel)]="Copy.IsAutomaticallyNotified">
                                Automatic Emails
                            </mat-checkbox>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Accounts">
                    <table class="mat-mdc-table" style="min-width: 400px">
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th style="text-align: right;">
                                <button type="button" mat-icon-button (click)="accountEditor.edit({Activation: Copy})">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </th>
                        </tr>
                        <tr *ngFor="let account of Copy.ActivationAccounts" [ngModelGroup]="account.randomNumber">
                            <td>{{account.Account?.getFullName()}}</td>
                            <td>{{account.Status?.Value}}</td>
                            <td style="text-align: right;">
                                <button type="button" mat-icon-button (click)="accountEditor.edit(account)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button type="button" mat-icon-button matTooltip="Send e-mail" (click)="eEditor.edit(accountEditor.generateEmail(account))">
                                    <mat-icon>email</mat-icon>
                                </button>
                                <button type="button" mat-icon-button appConfirmDialog
                                        (confirm)="accountEditor.remove(account)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </table>
                </mat-tab>
                <mat-tab label="Store Feedback">
                    <mat-form-field>
                      <mat-label>Store feedback</mat-label>
                        <textarea matInput [value]="Copy.ShopRemarks" disabled></textarea>
                    </mat-form-field>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button *ngIf="Copy.Id" [matMenuTriggerFor]="actions" mat-button mat-raised-button type="button">Actions</button>
            <mat-menu #actions="matMenu">
                <button (click)="mkDir();" [disabled]="isLoading" mat-menu-item>
                    Create directory /Activations/{{Copy.Id}}
                </button>
            </mat-menu>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>

    <app-email-editor #eEditor></app-email-editor>
    <app-activation-account-editor [(List)]="Copy.ActivationAccounts" #accountEditor [localOnly]="true"></app-activation-account-editor>
    <app-activation-article-editor [(List)]="Copy.ActivationArticles" #articleEditor></app-activation-article-editor>
    <app-crm-address-editor #aEditor [List]="Copy?.Relation?.Addresses" (ListChange)="Copy.Relation.Addresses = $event"></app-crm-address-editor>
    <app-crm-contact-editor #cEditor [List]="Copy?.Relation?.Contacts" (ListChange)="Copy.Relation.Contacts = $event"></app-crm-contact-editor>
</ng-template>
